import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';
import { PROMOTION_TYPES } from '@app/utils/constants/inventory-table.constant';
import { InventoryItemFullInformation } from '@app/utils/interfaces/inventory-item.interface';

@Component({
  selector: 'app-product-price-section',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    TranslatePipe,
  ],
  templateUrl: './product-price-section.component.html',
  styleUrl: './product-price-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductPriceSectionComponent implements OnInit {
  private readonly fb = inject(FormBuilder);

  public readonly item = input.required<InventoryItemFullInformation>();
  public readonly parentForm = input.required<FormGroup>();
  public readonly promotionTypes = PROMOTION_TYPES;
  public priceForm!: FormGroup;
  public isPromotionFocused = signal(false);

  public ngOnInit(): void {
    this.initForm();
  }

  public get hasPromotionError(): boolean {
    const control = this.priceForm.controls['promotionValue'];
    return control.invalid && (control.dirty || control.touched);
  }

  public onPromotionFocus(): void {
    this.isPromotionFocused.set(true);
  }

  public onPromotionBlur(): void {
    this.isPromotionFocused.set(false);
  }

  private initForm(): void {
    this.priceForm = this.fb.group({
      price: ['', [Validators.required, Validators.min(0)]],
      applyPromotion: [false],
      promotionType: [this.promotionTypes[0].value],
      promotionValue: ['', [Validators.min(0)]],
      promotionStartDate: [''],
      promotionEndDate: [''],
    });

    const parent = this.parentForm();

    if (!parent.contains('priceForm')) {
      parent.addControl('priceForm', this.priceForm);
    }
  }
}
